import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useAuth } from '../../context/AuthContext';
import './Login.css';

/**
 * Login component - Handles user authentication
 * Provides both employee and admin login options for testing
 */
const Login = () => {
  // Auth context methods
  const { login, loading, error } = useAuth();
  const navigate = useNavigate(); // Initialize navigate hook
  
  // Local state for form fields
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');

  /**
   * Pre-fill login form with test credentials
   * @param {string} role - 'employee' or 'admin'
   */
  const quickLogin = (role) => {
    if (role === 'employee') {
      setEmail('atshilaho@magadaniltd.com');
      setPassword('password123');
    } else if (role === 'admin') {
      setEmail('mukhethwa@magadaniltd.com');
      setPassword('password123');
    }
  };

  /**
   * Handle form submission
   * @param {Event} e - Form submit event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!email || !password) {
      setFormError('Please fill in all fields');
      return;
    }
    
    setFormError('');
    
    // Attempt login
    const result = await login(email, password);
    
    if (result.success) {
      // Redirect based on role using React Router
      const userRole = result.user.role;
      if (userRole === 'Admin') {
        navigate('/admin-dashboard'); // Use navigate instead of window.location
      } else {
        navigate('/employee-dashboard'); // Use navigate instead of window.location
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>DeskFlow</h1>
          <p>Internal IT Service Portal</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {/* Error messages */}
          {(formError || error) && (
            <div className="error-message">
              {formError || error}
            </div>
          )}
          
          {/* Email input */}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={loading}
            />
          </div>
          
          {/* Password input */}
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={loading}
            />
          </div>
          
          {/* Submit button */}
          <button 
            type="submit" 
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        {/* Quick login options for testing */}
        <div className="quick-login">
          <p>Quick Login (Testing)</p>
          <div className="quick-login-buttons">
            <button 
              type="button" 
              className="btn-employee"
              onClick={() => quickLogin('employee')}
            >
              Employee
            </button>
            <button 
              type="button" 
              className="btn-admin"
              onClick={() => quickLogin('admin')}
            >
              Admin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;